// @ts-expect-error Gatsby resolves SVG React components through webpack.
import { ReactComponent as Logo } from 'EasyRedmineGatsby/svg/Easy8_logo_private.svg'
// @ts-expect-error Gatsby resolves image assets through webpack.
import SocialFacebook from 'EasyRedmineGatsby/svg/social-facebook.svg'
// @ts-expect-error Gatsby resolves image assets through webpack.
import SocialLinkedin from 'EasyRedmineGatsby/svg/social-linkedin.svg'
// @ts-expect-error Gatsby resolves image assets through webpack.
import SocialTwitter from 'EasyRedmineGatsby/svg/social-twitter.svg'
// @ts-expect-error Gatsby resolves image assets through webpack.
import SocialYoutube from 'EasyRedmineGatsby/svg/social-youtube.svg'
import React from 'react'
import { IFooterData } from 'Shared/queries/layout-queries'
import { dt } from 'Shared/utils/dynamicRS'
import { getLocalizedUrl } from 'Shared/utils/localeURL'
import PuxLink from 'Shared/utils/PuxLink'
import { t } from 'ttag'

interface ContentMenuItem {
  contentType: 'ContentMenuItem'
  displayText: string
  render: string
}
interface LinkMenuItem {
  contentType: 'LinkMenuItem'
  linkMenuItem: {
    name: string
    url: string
  }
}

type MenuItem = ContentMenuItem | LinkMenuItem
interface CategoryItem {
  categoryItemName: string
  menuItemsList: {
    menuItems: MenuItem[]
  }
}
interface FooterData {
  menuItems: CategoryItem[]
}

interface FooterPropsType {
  footerData: IFooterData
  hasTrialBanner?: boolean
}

const getLink = (item: MenuItem) => {
  switch (item.contentType) {
    case `ContentMenuItem`:
      const itemData = JSON.parse(item.render)
      return (
        <PuxLink to={`${getLocalizedUrl(itemData.url)}`}>
          {item.displayText}
        </PuxLink>
      )
    case `LinkMenuItem`:
      return <a href={item.linkMenuItem.url}>{item.linkMenuItem.name}</a>
  }
}

const Footer: React.FunctionComponent<FooterPropsType> = (props) => {
  const footerData: FooterData = props.footerData.menu[0].menuItemsList
  const year = `${new Date().getFullYear()}`
  const footerIsoLinkKey = `Redmine.Footer.ISO.Link`
  const footerIsoLink = dt(footerIsoLinkKey).trim()
  const hasFooterIsoLink =
    footerIsoLink.length > 0 && footerIsoLink !== footerIsoLinkKey
  const footerIsoAlt = dt(`Redmine.Footer.ISO.Alt`)
  const footerIsoLogoUrl = `${process.env.GATSBY_ORCHARD_API_URL}/media/system/footer/iso-logo.svg`
  const socialLinks = [
    {
      icon: SocialFacebook,
      label: `Facebook`,
      url: t`Redmine.Social.Facebook`,
    },
    {
      icon: SocialTwitter,
      label: `Twitter`,
      url: t`Redmine.Social.Twitter`,
    },
    {
      icon: SocialLinkedin,
      label: `LinkedIn`,
      url: t`Redmine.Social.Linkedin`,
    },
    {
      icon: SocialYoutube,
      label: `Youtube`,
      url: t`Redmine.Social.Youtube`,
    },
  ]

  if (!footerData || !footerData?.menuItems) {
    console.log(footerData)
    return null
  }

  const footerClasses = [
    `Footer`,
    props.hasTrialBanner
      ? `Footer--withTrialBanner`
      : `Footer--withoutTrialBanner`,
  ]

  return (
    <footer className={footerClasses.join(` `)}>
      <div className='pux-container'>
        <div className='Footer-card'>
          <div className='Footer-navigation'>
            {footerData.menuItems?.map((cat, catIdx) => (
              <div className='FooterCol' key={catIdx}>
                <div className='FooterCol-content'>
                  <h4 className='FooterCol-title'>{cat.categoryItemName}</h4>
                  <ul className='FooterCol-list'>
                    {cat.menuItemsList?.menuItems &&
                      cat.menuItemsList.menuItems.length &&
                      cat.menuItemsList.menuItems?.map((item, itemIdx) => (
                        <li key={itemIdx}>{getLink(item)}</li>
                      ))}
                  </ul>
                </div>
              </div>
            ))}

            <div className='FooterCol FooterCol-social'>
              <div className='FooterCol-content'>
                <h4 className='FooterCol-title'>{t`Redmine.Footer.FollowUs`}</h4>
                <ul className='FooterCol-list FooterSocial-list'>
                  {socialLinks.map((social) => (
                    <li key={social.label}>
                      <a href={social.url} target='_blank' rel='noopener'>
                        <img
                          src={social.icon}
                          alt=''
                          className='FooterSocial-icon'
                          width={24}
                          height={24}
                          aria-hidden='true'
                        />
                        <span>{social.label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className='FooterBrand'>
            <div className='FooterLogo'>
              <Logo />
            </div>

            <div className='FooterISO'>
              {hasFooterIsoLink ? (
                <a href={footerIsoLink} target='_blank' rel='noopener'>
                  <img
                    src={footerIsoLogoUrl}
                    alt={footerIsoAlt}
                    width={295}
                    height={53}
                  />
                </a>
              ) : (
                <img
                  src={footerIsoLogoUrl}
                  alt={footerIsoAlt}
                  width={295}
                  height={53}
                />
              )}
            </div>
          </div>
        </div>

        <div className='Footer-foot'>
          <div className='Footer-copyright'>
            <div className='Footer-copyrightText'>
              {t`Redmine.Footer.Copyright`.replace(`%currentYear%`, year)}
            </div>
            <div className='Footer-sitemap'>
              <span>This site is protected by Cloudflare Turnstile.</span>
              <br />
              <span>
                Cloudflare&apos;s{` `}
                <a href='https://www.cloudflare.com/privacypolicy/'>
                  Privacy Policy
                </a>
                {` `}
                and{` `}
                <a href='https://www.cloudflare.com/website-terms/'>
                  Terms of Use
                </a>
                {` `}
                apply.
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
